import { createFileRoute } from "@tanstack/react-router";
import { MfeLoader } from "../mfe/MfeLoader";
import { getAgentRuntimeAuthzHostConfig } from "../config/agentRuntimeAuthzHostConfig";
import { useHostNavigate } from "../hooks/useHostNavigate";

export const Route = createFileRoute("/agent-runtime-authz/$")({
  component: AgentRuntimeAuthzMfePage,
});

function AgentRuntimeAuthzMfePage() {
  const onNavigate = useHostNavigate();
  return (
    <MfeLoader
      name="agent-runtime-authz"
      props={{ hostConfig: getAgentRuntimeAuthzHostConfig(onNavigate) }}
    />
  );
}
